module.exports = __webpack_public_path__ + "9c6c7b7eeca1ddf8070852b496f001df.svg";